import styled from '@emotion/styled';
import {DialogContent} from '@radix-ui/react-dialog';

export const Content = styled(DialogContent)`
  box-sizing: border-box;
  position: fixed;
  z-index: 4;
  outline: 0;
  overflow: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  width: 100%;
  max-width: 343px;
  text-align: center;
  border-radius: 5px;
  ${({theme}) => theme.elevations.large};
`;
